<template>
  <div class="list-view-filter">
    <label class="filter-label">Cuentas</label>
    <b-button variant="outline-dark" size="sm" class="accounting-accounts-filter__button" block @click="open()"><AppIcon name="checklist" class="mr-1" />{{ summary }}</b-button>

    <b-modal v-model="modal.active"
             size="lg"
             :key="'accounts_' + modal._id"
             :id="modal._id">
      <div slot="modal-header" minimize class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon name="checklist" /></span>
        <h5 class="app-modal-header__title">Seleccionar cuentas</h5>
      </div>

      <div class="accounting-accounts-filter__toolbar">
        <b-button size="sm" variant="outline-dark" @click="selectAll()">Todas</b-button>
        <b-button size="sm" variant="outline-secondary" class="ml-1" @click="$emit('input', [])">Ninguna</b-button>
      </div>
      <div class="accounting-accounts-filter__list">
        <div v-for="account in visiblePlan" :key="'account_plan_' + account.id" class="accounting-accounts-filter__row" :style="{ paddingLeft: (account.level * 16) + 'px' }">
          <b-button size="sm"
                    variant="link"
                    class="accounting-accounts-filter__toggle"
                    @click="toggleExpanded(account)"
                    :disabled="!account.children_ids.length">
            <AppIcon :name="isExpanded(account.id) ? 'expand_more' : 'chevron_right'" v-if="account.children_ids.length" />
          </b-button>
          <b-form-checkbox size="sm"
                           :checked="isSelected(account.id)"
                           @change="toggleAccount(account, $event)">
            <span :class="{ 'font-weight-bold': account.children_ids.length }">
              {{ account.code }} - {{ account.name }}
            </span>
          </b-form-checkbox>
        </div>
      </div>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" @click="modal.active=false"><AppIcon name="close" class="mr-1" />Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import serviceAPI from '../services'
  import Error from '@/handler/error'

  // Selector de cuentas del plan. v-model: ids elegidos; null hasta cargar el plan significa "todas".
  export default {
    props: {
      value: {
        type: Array,
        default: null,
      },
    },
    data: () => {
      return {
        plan: [],
        expandedIds: [],
        modal: {
          active: false,
          _id: '',
        },
      }
    },
    computed: {
      selectedIds() {
        return this.value || []
      },
      summary() {
        if(!this.plan.length) {
          return 'Cargando plan de cuentas...'
        }

        if(this.selectedIds.length == this.plan.length) {
          return 'Todas las cuentas'
        }

        if(!this.selectedIds.length) {
          return 'Sin cuentas seleccionadas'
        }

        return this.selectedIds.length + ' cuenta(s) seleccionada(s)'
      },
      visiblePlan() {
        return this.plan.filter(account => {
          let parentId = account.level == 0 ? null : account.parent_id
          while(parentId) {
            if(this.expandedIds.indexOf(parentId) < 0) {
              return false
            }

            const parent = this.plan.find(item => item.id == parentId)
            parentId = parent ? parent.parent_id : null
          }

          return true
        })
      },
    },
    watch: {
      value(value) {
        if(value === null && this.plan.length) {
          this.selectAll()
        }
      },
    },
    mounted() {
      this.loadPlan()
    },
    methods: {
      loadPlan() {
        serviceAPI.filtrarPlanCuenta()
        .then(response => {
          const plan = []
          this.flatten(response.data || [], 0, plan)
          this.plan = plan
          this.$emit('plan-loaded', plan)

          if(this.value === null) {
            this.selectAll()
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      flatten(accounts, level, plan) {
        accounts.forEach(account => {
          const children = account.children_recurrent || account.children || []
          const flatAccount = {
            id: account.id,
            code: account.code,
            name: account.name,
            parent_id: account.parent_id,
            level: level,
            children_ids: [],
          }

          plan.push(flatAccount)

          if(children.length) {
            this.flatten(children, level + 1, plan)
            flatAccount.children_ids = this.collectChildrenIds(children)
          }
        })
      },
      collectChildrenIds(children) {
        let ids = []
        children.forEach(child => {
          ids.push(child.id)
          const childChildren = child.children_recurrent || child.children || []
          if(childChildren.length) {
            ids = ids.concat(this.collectChildrenIds(childChildren))
          }
        })
        return ids
      },
      open() {
        this.modal._id = Math.random().toString(36).slice(2, 8)
        this.modal.active = true
      },
      selectAll() {
        this.$emit('input', this.plan.map(account => account.id))
      },
      isSelected(id) {
        return this.selectedIds.indexOf(id) >= 0
      },
      toggleAccount(account, selected) {
        const selectedIds = this.selectedIds.slice()
        ;[account.id].concat(account.children_ids).forEach(id => {
          const index = selectedIds.indexOf(id)
          if(selected && index < 0) {
            selectedIds.push(id)
          }
          if(!selected && index >= 0) {
            selectedIds.splice(index, 1)
          }
        })
        this.$emit('input', selectedIds)
      },
      isExpanded(id) {
        return this.expandedIds.indexOf(id) >= 0
      },
      toggleExpanded(account) {
        const index = this.expandedIds.indexOf(account.id)
        if(index >= 0) {
          this.expandedIds.splice(index, 1)
        } else {
          this.expandedIds.push(account.id)
        }
      },
    }
  }
</script>
<style scoped>
  .accounting-accounts-filter__button {
    height: 31px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }

  .accounting-accounts-filter__toolbar {
    padding: 8px;
    border-bottom: 1px solid #e4e7ea;
    background: #f8f9fa;
  }

  .accounting-accounts-filter__list {
    max-height: 470px;
    overflow: auto;
    padding: 8px;
  }

  .accounting-accounts-filter__row {
    min-height: 28px;
    display: flex;
    align-items: center;
  }

  .accounting-accounts-filter__toggle {
    width: 24px;
    height: 24px;
    padding: 0;
    margin-right: 2px;
    color: #343a40;
  }
</style>
